import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation User_evaluateCourse(
    $ids: [ID!]!
    $userCourseStatus: String!
    $url: String
    $evaluationDate: String
    $instructorId: ID
    $instructorUserId: ID
  ) {
    User_evaluateCourse(
      ids: $ids
      userCourseStatus: $userCourseStatus
      url: $url
      evaluationDate: $evaluationDate
      instructorId: $instructorId
      instructorUserId: $instructorUserId
    ) {
      status
    }
  }
`;

/**
 * Aprueba/cambia el estatus de N userCourses (mismo curso) en una sola llamada.
 *
 * @param {Object} params
 * @param {string[]} params.ids - Array de userCourseId. Mínimo 1.
 * @param {string} params.userCourseStatus - "Aprobado" | "Reprobado" | "Por Cursar".
 * @param {string} [params.url] - S3 key de la evidencia. Omitir si no aplica.
 * @param {string} [params.evaluationDate] - ISO 8601. Omitir para usar fecha actual del backend.
 * @param {string} [params.instructorId] - UUID del instructor externo (catálogo). Omitir para que el backend ligue a "Kappa".
 * @param {string} [params.instructorUserId] - UUID del instructor interno (empleado). Excluyente con instructorId.
 * @returns {Promise<{ status: boolean, errorMessage?: string }>}
 */
const userEvaluateCourse = async ({ ids, userCourseStatus, url, evaluationDate, instructorId, instructorUserId }) => {
  const variables = { ids, userCourseStatus };
  if (url !== undefined && url !== null && url !== '') {
    variables.url = url;
  }
  if (evaluationDate) {
    variables.evaluationDate = evaluationDate;
  }
  // Excluyentes: el backend nunca debe recibir ambos. instructorId tiene prioridad si por error llegaran los dos.
  if (instructorId) {
    variables.instructorId = instructorId;
  } else if (instructorUserId) {
    variables.instructorUserId = instructorUserId;
  }

  const data = await graphql(mutation, variables);

  if (data?.error) {
    return { status: false, errorMessage: data.errorMessage };
  }
  return data.User_evaluateCourse;
};

export default userEvaluateCourse;
